"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EMPLOYEE_SUMMARY_SYNTHETIC_PERSONA_COLLECTION () {
        return EMPLOYEE_SUMMARY_SYNTHETIC_PERSONA_COLLECTION;
    },
    get EmployeeSummarySyntheticPersonaSchema () {
        return EmployeeSummarySyntheticPersonaSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const ObjectIdSchema = _zod.z.instanceof(_bson.ObjectId);
const AxesSchema = _zod.z.object({
    archetype: _zod.z.enum([
        "high_performer",
        "steady",
        "struggling",
        "new_hire",
        "coasting_veteran"
    ]),
    trajectory: _zod.z.enum([
        "improving",
        "stable",
        "declining",
        "volatile"
    ]),
    sparsity: _zod.z.enum([
        "full_data",
        "no_peer_feedback",
        "no_manager_1on1",
        "only_self_review",
        "no_goals"
    ]),
    role_context: _zod.z.enum([
        "ic_no_reports",
        "ic_remote",
        "tl_with_reports",
        "manager_small",
        "manager_large"
    ])
});
const EmployeeSummarySyntheticPersonaSchema = _zod.z.object({
    _id: ObjectIdSchema,
    persona_id: _zod.z.string().min(1),
    user_id: ObjectIdSchema,
    company_id: ObjectIdSchema,
    pod_id: _zod.z.string().min(1),
    axes: AxesSchema,
    seed: _zod.z.string().min(1),
    spec_hash: _zod.z.string().min(1),
    created_at: _zod.z.date(),
    generator_version: _zod.z.string().min(1)
});
const EMPLOYEE_SUMMARY_SYNTHETIC_PERSONA_COLLECTION = "employee_summary_synthetic_personas";
